<div class="global-search global-search--desktop">
  <mat-icon class="global-search__icon">search</mat-icon>
  <input
    class="global-search__input"
    type="text"
    [formControl]="searchControl"
    placeholder="Buscar miembros o unidades"
    aria-label="Buscar miembros o unidades"
    (focus)="openDesktop()"
  />
  <button *ngIf="searchControl.value" type="button" class="global-search__clear" aria-label="Limpiar busqueda" (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
  <ng-container *ngTemplateOutlet="resultsPanel"></ng-container>
</div>

<button mat-icon-button class="global-search__mobile-button" aria-label="Buscar miembros o unidades" (click)="openMobile()">
  <mat-icon>search</mat-icon>
</button>

<div *ngIf="mobileOpen" class="global-search-mobile">
  <div class="global-search-mobile__bar">
    <button mat-icon-button aria-label="Cerrar busqueda" (click)="close()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <input
      #mobileInput
      class="global-search-mobile__input"
      type="text"
      [formControl]="searchControl"
      placeholder="Buscar miembros o unidades"
      aria-label="Buscar miembros o unidades"
    />
    <button *ngIf="searchControl.value" mat-icon-button aria-label="Limpiar busqueda" (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="global-search-mobile__panel">
    <ng-container *ngTemplateOutlet="resultsContent"></ng-container>
  </div>
</div>

<ng-template #resultsPanel>
  <div *ngIf="open" class="global-search__panel">
    <ng-container *ngTemplateOutlet="resultsContent"></ng-container>
  </div>
</ng-template>

<ng-template #resultsContent>
  <div *ngIf="loading" class="global-search__state">
    <mat-spinner diameter="20"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading && hasResults">
    <section *ngIf="results.people.length" class="global-search__section">
      <div class="global-search__section-title">Miembros</div>
      <button
        *ngFor="let person of results.people"
        type="button"
        class="global-search__result"
        (click)="navigateToPerson(person)"
      >
        <mat-icon>person</mat-icon>
        <span class="global-search__result-text">
          <span class="global-search__result-title">{{ person.fullName }}</span>
          <span class="global-search__result-subtitle">{{ person.membershipUnitName }}</span>
        </span>
      </button>
    </section>

    <section *ngIf="results.units.length" class="global-search__section">
      <div class="global-search__section-title">Unidades</div>
      <button
        *ngFor="let unit of results.units"
        type="button"
        class="global-search__result"
        (click)="navigateToUnit(unit)"
      >
        <mat-icon *ngIf="!isSvgIcon(getUnitIcon(unit))">{{ getUnitIcon(unit) }}</mat-icon>
        <mat-icon *ngIf="isSvgIcon(getUnitIcon(unit))" [svgIcon]="getUnitIcon(unit)"></mat-icon>
        <span class="global-search__result-text">
          <span class="global-search__result-title">{{ unit.name }}</span>
          <span class="global-search__result-subtitle">
            {{ unit.levelName }}<ng-container *ngIf="unit.parentName"> - {{ unit.parentName }}</ng-container>
          </span>
        </span>
      </button>
    </section>
  </ng-container>

  <div *ngIf="!loading && searched && !hasResults" class="global-search__state">
    Sin resultados
  </div>
</ng-template>
